import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import Header from '../../main/components/Header';
import MobileBottomBar from '../../main/components/MobileBottomBar';
import Path from '../../path/ui/Path';

import { I18nextProvider } from 'react-i18next';
import i18n from '../../../language/i18n';
import PromoteContent from '../components/PromoteContent';
import { t } from 'i18next';

function Main() {
    const [bottomBarHidden, setBottomBarHidden] = useState(false);
    const location = useLocation();
    const adData = location.state?.ad || {};

    const handleBottomBarToggle = (isHidden) => {
        setBottomBarHidden(isHidden);
    };

    return (
        <I18nextProvider i18n={i18n}>
            <Header onToggleMenu={handleBottomBarToggle} />
            <Path currentPath={t('promote')} />
            <PromoteContent data={adData} />
            {!bottomBarHidden && <MobileBottomBar activeTabName={'home'} />}
        </I18nextProvider>
    );
}

export default Main;